import React, { useEffect, EffectCallback, DependencyList } from 'react';

/**
 * Modified verion of useEffect that will only run after the first render.
 */
export const useUpdateEffect = (cb: EffectCallback, deps?: DependencyList): void => {
  const firstRender = React.useRef(false);

  useEffect(() => {
    if (!firstRender.current) {
      firstRender.current = true;
      return;
    }

    return cb();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
